// interfaces/user.js
import axios from '@/interfaces'

/**
 * 登出
 */
export const logout = () => {
	return axios.put('/user/logout').then(res => res.data)
}

/**
 * 验证认证令牌
 */
export const verifyAuthToken = (token) => {
	return axios.get('/user/checkToken', {
		params: { token: token || '' }
	}).then(res => res.data)
}

/**
 * 获取余额
 */
export const getBalance = () => {
	return axios.get('/user/balance').then(res => res.data)
}

/**
 * 获取最近一个月的充值历史
 */
export const lastMonthRecharge = () => {
	return axios.get('/user/lastMonthRecharge').then(res => res.data)
}
/**
 * 获取用户信息
 */
export const getUserInfo = () => {
	return axios.get('/user/get').then(res => res.data)
}
/**
 * 修改用户个人信息
 */
export const modifyBasic = (data) => {
	return axios.post('/user/v1/modify/basic', data).then(res => res.data)
}

/**
 * 更新用户服务地区信息
 * @param {Object} locationInfo - 位置信息对象
 * @param {string} locationInfo.province - 省份名称
 * @param {string} locationInfo.city - 城市名称
 * @param {string} locationInfo.name - 位置名称
 * @param {number|string} locationInfo.lng - 经度
 * @param {number|string} locationInfo.lat - 纬度
 */
export const updateUserGeolocation = (locationInfo) => {
	const data = {
		serviceProvinceName: locationInfo.province || '',
		serviceCityName: locationInfo.city || '',
		servicePlace: locationInfo.name || '',
		longitude: locationInfo.lng || locationInfo.longitude || 0,
		latitude: locationInfo.lat || locationInfo.latitude || 0
	}
	return axios.post('/user/v1/update/service-location', data).then(res => res.data)
}

/**
 * 修改手机号
 */
export const changeMobile = (data) => {
	return axios.post('/user/v1/change/mobile', data).then(res => res.data)
}

/**
 * 用户注销
 */
export const cancelUser = () => {
	return axios.post('/user/cancel').then(res => res.data)
}
